import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'MOD',
  category: FunctionCategory.MATH,
  description:
    'Modulo (remainder) operation on each number in a column or a single number, when divided by either a column or number.',
  shortDescription: 'Modulo (remainder) operation',
  params: [
    {
      name: 'dividend',
      type: ArgType.number,
      description: 'Either a column or number to be divided to find the remainder.',
    },
    {
      name: 'divisor',
      type: ArgType.number,
      description: 'Either a column or number to divide by.',
    },
  ],
} satisfies AnalysisFunction;
